import { AdminPageHeader } from '@/components/patterns/admin-page'
import AddOnSetForm from '@/components/forms/AddOnSetForm'
import { createFileRoute, notFound } from '@tanstack/react-router'
import { PackagePlus } from 'lucide-react'

export const Route = createFileRoute('/_authenticated/$orgId/products/add-on-sets/create')({
  beforeLoad: ({ context }) => {
    if (!context.ability.can('create', 'products')) throw notFound()
  },
  loader: () => ({ isReadOnly: false }),
  component: AddOnSetCreatePage,
})

export function AddOnSetCreatePage() {
  const { orgId } = Route.useParams()

  return (
    <div className="space-y-4">
      <AdminPageHeader icon={PackagePlus} title="Create Add-on Collection" />
      <AddOnSetForm organizationId={orgId} />
    </div>
  )
}
